document.addEventListener("DOMContentLoaded", function(){
  callScrollMagic();
});

function initPopup(couponCodeText, popupSuccessText){
  let newsletterFormPopup = document.getElementById("nlPopup");
  if(newsletterFormPopup != null){
    let formSelector = "#newsletterFormPopup";
    let elems = {
      'nlPopupMail': {'required': true, 'default': null},
      'nlPopupPrivacy': {'required': true, 'default': null},
      'nlPopupOtpStat': {'required': false, 'default': null},
      'nlPopupOtpProfiling': {'required': false, 'default': null},
    }
  
    contactForm = new FormController(formSelector, elems, document.querySelector("#subscribePopup"), window.contactDomain + localeForm+"/mail.mngr",
      {
        successPopupId: 'newsletterConfirmedPopup',
        initCallback: function(){
          let elem = this.formNode.querySelector("#nlPopupMail");
          elem.addEventListener('input', e => {
            if(elem.value == ""){
              this.formNode.querySelector(".privacyContentBlock").classList.remove("show");
            }
            else{
              this.formNode.querySelector(".privacyContentBlock").classList.add("show");
            }
          })
        },
        callbacks: {
          success: function(feedback){
            if(getCookie("donePopup") == ""){
              let contentPopup = newsletterFormPopup.querySelector(".contentWrapper");
              contentPopup.style.opacity = 0;
              setTimeout(function(){
                if(getCookie("donePopup") == ""){
                  setCookie("donePopup", true, 30);
                }
                contentPopup.innerHTML = "";
                contentPopup.innerHTML = "<p class='mt-3 mb-4 font-weight-bold text-center'>"+popupSuccessText+"</p><div class='couponCodeWrapper'><span class='couponCode d-flex align-items-center bgColorRed justify-content-center'>"+couponCodeText+"<span class='mr-3'></span><svg xmlns='http://www.w3.org/2000/svg' width='28.5' height='33' viewBox='0 0 28.5 33'><path id='Icon_material-content-copy' data-name='Icon material-content-copy' d='M24,1.5H6a3.009,3.009,0,0,0-3,3v21H6V4.5H24Zm4.5,6H12a3.009,3.009,0,0,0-3,3v21a3.009,3.009,0,0,0,3,3H28.5a3.009,3.009,0,0,0,3-3v-21A3.009,3.009,0,0,0,28.5,7.5Zm0,24H12v-21H28.5Z' transform='translate(-3 -1.5)' fill='#fff'/></svg></span><input type='hidden' id='discount' value='"+couponCodeText+"'></div>";
                contentPopup.style.opacity = 1;
                let couponCode = contentPopup.querySelector('.couponCode');
                let couponCodeWrapper = contentPopup.querySelector('.couponCodeWrapper');
                let couponCodeBtn = document.getElementById('discount');
                setCustomFeedback(document.querySelector('#nlPopup .mainColumn'), feedback);
                couponCode.addEventListener('click', function(){
  
                  // Copy the text inside the text field
                  navigator.clipboard.writeText(couponCodeBtn.value);
                  couponCodeWrapper.classList.add('copied');
                  setTimeout(function(){
                    couponCodeWrapper.classList.remove('copied');
                  }, 900)
                })
              }, 300)
            }
          },
          error: function(feedback){
            setCustomFeedback(document.querySelector('#nlPopup .mainColumn'), feedback);
          },
          validationError: function(feedback){
            setCustomFeedback(document.querySelector('#nlPopup .mainColumn'), feedback);
          }
        }
      }
    );
    
    let closeBtn = newsletterFormPopup.querySelector('.closePopup');

    closeBtn.addEventListener('click', function(){
      newsletterFormPopup.classList.add("hide");
      setTimeout(function(){
        newsletterFormPopup.style.display = "none";
        if(getCookie("closedPopup") == ""){
          setCookie("closedPopup", true, 1);
        }
      }, 500)
    });

    setTimeout(function(){
      if(getCookie("closedPopup") == "" && getCookie("donePopup") == ""){
       newsletterFormPopup.classList.remove("hide");
      }else{
       newsletterFormPopup.style.display = "none";
      }
    }, 500)

  }
}

function setCustomFeedback(element, data){
  console.log(data);
  let alreadyExisting = element.querySelector(".customPopupFeedback");
  console.log(alreadyExisting);
  if(alreadyExisting){
    element.querySelector(".closeIcon").click();
  }
  let feedbackContainer = document.createElement("div");
  feedbackContainer.classList.add("customPopupFeedback");
  feedbackContainer.classList.add(data.type);
  feedbackContainer.textContent = data.title;
  feedbackContainer.innerHTML = feedbackContainer.textContent + data.content;
  let closeIcon = document.createElement("span");
  closeIcon.classList.add("closeIcon");
  feedbackContainer.appendChild(closeIcon);
  closeIcon.addEventListener("click", function(){
    feedbackContainer.classList.remove("scrollIn");
    setTimeout(function(){
      feedbackContainer.remove();
    }, 350)
  })

  element.appendChild(feedbackContainer);
  setTimeout(function(){
    feedbackContainer.classList.add("scrollIn");
  }, 100)

}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let controller = new ScrollMagic.Controller();


function setScroll(element) {
  if (element != null) {

    let toAnimateChilds = element.querySelectorAll('.toAnimate');
    toAnimateChilds.forEach(el => {
      let hook = document.getElementById('top').offsetHeight/window.innerHeight;
      let animate = el,
      trigger = animate,
      delay = 0,
      classAnim = animate.dataset.class || '',
      offset = animate.dataset.triggerOffset || 0,
      resolution = element.dataset.resolution || 0;


      if(window.innerWidth >= resolution){
        trigger = element;
        delay = animate.dataset.delay || 0;
        offset = element.dataset.triggerOffset || 0;
      }


      if(window.innerWidth < 768){
        offset = offset - 100;
      }

      if(window.innerWidth > 1800){
        offset = offset - 100;
      }


      if(window.innerWidth > 2600){
        offset = offset - 600;
      }
      new ScrollMagic.Scene({
        triggerElement: trigger,
        offset: offset,
        triggerHook:hook,
        reverse: false
      }).on('enter', function () {
          if (delay == 0) {
            animate.classList.add(classAnim);
          }else {
            setTimeout(function() {
              animate.classList.add(classAnim);
            }, delay);
          }
        })
        //.addIndicators()
        .addTo(controller);
    })
  }
}

function callScrollMagic() {
  let toAnimateElems = document.querySelectorAll('.toAnimateTrigger');
  toAnimateElems.forEach(element => {
    setScroll(element);    
  });
}
